/* Layout */
import Layout from '@/layout'

export default {
  path: '/prescription',
  component: Layout,
  redirect: '/prescription/YaocaiAttribute',
  name: 'prescription',
  meta: { title: '中医处方', icon: 'prescription' },
  children: [
    {
      path: 'YaocaiAttribute',
      name: 'YaocaiAttribute',
      component: () => import('@/views/info/yaocai/attribute/index'),
      meta: { title: '药材属性', icon: 'yaocai-manage' }
    },
    {
      path: 'YaocaiInfo',
      name: 'YaocaiInfo',
      component: () => import('@/views/info/yaocai/info/index'),
      meta: { title: '药材信息', icon: 'yaocai' }
    }
  ]
}
